export default "__VITE_ASSET__b36ebfc5__"